// removed by extract-text-webpack-plugin
module.exports = {"noDataContainer":"TableNoData-noDataContainer","noDataContent":"TableNoData-noDataContent","iconContainer":"TableNoData-iconContainer"};